const state = {
	isLoading: true,
	item1List:[],
	item2List:[],
	curItem1Name: '',
	itemLevel: 1,
}

const mutations = {
	'UPDATE_ITEM1_LIST' (state, item1List) {
		state.item1List = item1List
		state.isLoading = false
	},
	'UPDATE_ITEM2_LIST' (state, item1Name) {
		state.curItem1Name = item1Name
		state.item2List = []
		for (let i = 0; i < state.item1List.length; i++) {
			if (state.item1List[i]['name'] == item1Name){
				state.item2List = state.item1List[i]['items2']
				for (let j=0; j<state.item2List.length; j++){
					state.item2List[j].item1Name = item1Name
				}
				break
			}
		}
	},
	'UPDATE_SHOW_ITEM_LEVEL' (state, itemLevel) {
		state.itemLevel = itemLevel
	},
}

const actions = {
	setItem1List: ({commit}, {item1List}) => {
		commit('UPDATE_ITEM1_LIST', item1List);
	},
	setItem2List: ({commit}, {item1name}) => {
		commit('UPDATE_ITEM1_LIST', item1name);
	},
	setItemLevel: ({commit}, {itemLevel}) => {
		commit('UPDATE_SHOW_ITEM_LEVEL', itemLevel);
	},
}

const getters = {
	itemLevel: (state) => {
		return state.itemLevel;
	},
	items1: (state) => {
		return state.item1List;
	},
	items2: (state) => {
		return state.item2List;
	},
	curItem1Name: (state) => {
		return state.curItem1Name || (state.item2List.length > 0 ? state.item2List[0].item1Name : '');
	},
	isProductLoading: (state) => {
		return state.isLoading;
	}
}

export default {
	state,
	mutations,
	actions,
	getters
}